export default function StrengthsSection() {
  const strengths = [
    {
      title: "お客様にあわせた「最適提案力」",
      description: "DJI、FJD、EFIX、Farmoなど複数社製品から、お客様の課題・圃場・予算に合ったベストな製品を中立的に提案。メーカーに縛られない幅広いラインナップで真に最適なソリューションを提供します。"
    },
    {
      title: "導入後も安心の「地域密着サポート」",
      description: "佐賀・福岡・鹿児島に拠点を構え、操作指導から点検・整備、トラブル対応まで専門スタッフが迅速対応。「売りっぱなし」は絶対にしません。導入前デモから継続サポートまで安心体制を整備。"
    },
    {
      title: "資格取得まで可能な「一貫体制」",
      description: "農業ドローン協議会認定スクール運営。購入から操縦士育成まですべて対応。機器導入から人材育成、運用支援まで一貫サポートが強みです。"
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
            農業のプロに選ばれる理由
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {strengths.map((strength, index) => (
            <div key={index} className="bg-gradient-to-br from-green-50 to-blue-50 rounded-xl p-8 border border-green-100">
              <div className="flex items-center justify-center w-12 h-12 bg-[#2A6041] text-white rounded-lg mb-6 mx-auto">
                <span className="text-xl font-bold">{index + 1}</span>
              </div>
              {index === 0 && (
                <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">
                  お客様にあわせた<br />
                  「最適提案力」
                </h3>
              )}
              {index === 1 && (
                <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">
                  導入後も安心の<br />
                  「地域密着サポート」
                </h3>
              )}
              {index === 2 && (
                <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">
                  資格取得まで可能な<br />
                  「一貫体制」
                </h3>
              )}
              <p className="text-gray-700 leading-relaxed">
                {strength.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}